<template>
  <div class>
    <section
      id="sectionId"
      class="d-flex body-content new-addendee-list attendee_List"
      style="background-color: #f1f3f4"
    >
      <div class="add-speaker-container">
        <div class="container-fluid">
          <div class="add-speaker-butn" data-toggle="modal" data-target="#addspeakerModalCenter">
            <p><span><v-icon color="#000" size="35px">mdi-plus</v-icon></span> Add Speaker</p>
          </div>

          <div class="publish-modal-button mt-8">
            <v-btn dark color="blue" width="100px" data-toggle="modal" data-target="#EventPublishModalCenter">Publish</v-btn>
          </div>

                <input
                      type="file"
                      class="custom--inputfile"
                      @change="update_avatar"
                      accept="image/*"
                    />


                       <cropper v-if="cropImageUrl"
                :key="resetCropper"
                v-bind:aspectValue="imageRatio"
                :sourceImage="cropImageUrl"
                @croppedImagePath="croppedImagePath"
              />

        </div>
      </div>

      <!-- Modal -->
      <div class="modal fade addspeakermodal" id="addspeakerModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            
            <div class="modal-body">
              <div class="invite-speaker-head postion-relative">
                <h3>Invite speakers</h3>
                <p data-dismiss="modal" aria-label="Close"><v-icon color="#000" size="25px">mdi-close</v-icon></p>
              </div>
              <div class="speaker-selection-wrapper">
              <div class="speaker-list-selection p-3 pb-0 pr-0">
                <div class="speaker-selection-search-box position-relative pr-3">
                  <input type="text" name="" id="" value="" placeholder="Search Speakers"/>
                  <p><v-icon color="#959595" size="30px">mdi-magnify</v-icon></p>
                </div>
                <div class="speaker-selection-list">
                    <div class="speaker-selection-list-head">
                      <h4>Speakers</h4>
                      <p>Select all<v-checkbox v-model="checkbox"></v-checkbox></p>
                    </div>
                    <div class="single-speaker-selection">
                      <div class="d-flex justify-content-start align-items-center">
                        <div class="speaker-ico-initial">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <h3>Floyd L. Santos</h3>
                      </div>
                      <v-checkbox v-model="checkbox2"></v-checkbox>
                    </div>
                    <div class="single-speaker-selection">
                      <div class="d-flex justify-content-start align-items-center">
                        <div class="speaker-ico-initial">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <h3>Floyd L. Santos</h3>
                      </div>
                      <v-checkbox v-model="checkbox2"></v-checkbox>
                    </div>
                    <div class="single-speaker-selection">
                      <div class="d-flex justify-content-start align-items-center">
                        <div class="speaker-ico-initial">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <h3>Floyd L. Santos</h3>
                      </div>
                      <v-checkbox v-model="checkbox2"></v-checkbox>
                    </div>
                    <div class="single-speaker-selection">
                      <div class="d-flex justify-content-start align-items-center">
                        <div class="speaker-ico-initial">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <h3>Floyd L. Santos</h3>
                      </div>
                      <v-checkbox v-model="checkbox2"></v-checkbox>
                    </div>
                    <div class="single-speaker-selection">
                      <div class="d-flex justify-content-start align-items-center">
                        <div class="speaker-ico-initial">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <h3>Floyd L. Santos</h3>
                      </div>
                      <v-checkbox v-model="checkbox2"></v-checkbox>
                    </div>
                    <div class="single-speaker-selection">
                      <div class="d-flex justify-content-start align-items-center">
                        <div class="speaker-ico-initial">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <h3>Floyd L. Santos</h3>
                      </div>
                      <v-checkbox v-model="checkbox2"></v-checkbox>
                    </div>
                    <div class="single-speaker-selection">
                      <div class="d-flex justify-content-start align-items-center">
                        <div class="speaker-ico-initial">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <h3>Floyd L. Santos</h3>
                      </div>
                      <v-checkbox v-model="checkbox2"></v-checkbox>
                    </div>
                    <div class="single-speaker-selection">
                      <div class="d-flex justify-content-start align-items-center">
                        <div class="speaker-ico-initial">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <h3>Floyd L. Santos</h3>
                      </div>
                      <v-checkbox v-model="checkbox2"></v-checkbox>
                    </div>
                    <div class="single-speaker-selection">
                      <div class="d-flex justify-content-start align-items-center">
                        <div class="speaker-ico-initial">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <h3>Floyd L. Santos</h3>
                      </div>
                      <v-checkbox v-model="checkbox2"></v-checkbox>
                    </div>
                    <div class="single-speaker-selection">
                      <div class="d-flex justify-content-start align-items-center">
                        <div class="speaker-ico-initial">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <h3>Floyd L. Santos</h3>
                      </div>
                      <v-checkbox v-model="checkbox2"></v-checkbox>
                    </div>
                    <div class="single-speaker-selection">
                      <div class="d-flex justify-content-start align-items-center">
                        <div class="speaker-ico-initial">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <h3>Floyd L. Santos</h3>
                      </div>
                      <v-checkbox v-model="checkbox2"></v-checkbox>
                    </div>
                    <div class="single-speaker-selection">
                      <div class="d-flex justify-content-start align-items-center">
                        <div class="speaker-ico-initial">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <h3>Floyd L. Santos</h3>
                      </div>
                      <v-checkbox v-model="checkbox2"></v-checkbox>
                    </div>
                    <div class="single-speaker-selection">
                      <div class="d-flex justify-content-start align-items-center">
                        <div class="speaker-ico-initial">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <h3>Floyd L. Santos</h3>
                      </div>
                      <v-checkbox v-model="checkbox2"></v-checkbox>
                    </div>
                    <div class="single-speaker-selection">
                      <div class="d-flex justify-content-start align-items-center">
                        <div class="speaker-ico-initial">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <h3>Floyd L. Santos</h3>
                      </div>
                      <v-checkbox v-model="checkbox2"></v-checkbox>
                    </div>
                    <div class="single-speaker-selection">
                      <div class="d-flex justify-content-start align-items-center">
                        <div class="speaker-ico-initial">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <h3>Floyd L. Santos</h3>
                      </div>
                      <v-checkbox v-model="checkbox2"></v-checkbox>
                    </div>
                    <div class="single-speaker-selection">
                      <div class="d-flex justify-content-start align-items-center">
                        <div class="speaker-ico-initial">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <h3>Floyd L. Santos</h3>
                      </div>
                      <v-checkbox v-model="checkbox2"></v-checkbox>
                    </div>
                    <div class="single-speaker-selection">
                      <div class="d-flex justify-content-start align-items-center">
                        <div class="speaker-ico-initial">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <h3>Floyd L. Santos</h3>
                      </div>
                      <v-checkbox v-model="checkbox2"></v-checkbox>
                    </div>
                    <div class="single-speaker-selection">
                      <div class="d-flex justify-content-start align-items-center">
                        <div class="speaker-ico-initial">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <h3>Floyd L. Santos</h3>
                      </div>
                      <v-checkbox v-model="checkbox2"></v-checkbox>
                    </div>
                    <div class="single-speaker-selection">
                      <div class="d-flex justify-content-start align-items-center">
                        <div class="speaker-ico-initial">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <h3>Floyd L. Santos</h3>
                      </div>
                      <v-checkbox v-model="checkbox2"></v-checkbox>
                    </div>
                    <div class="single-speaker-selection">
                      <div class="d-flex justify-content-start align-items-center">
                        <div class="speaker-ico-initial">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <h3>Floyd L. Santos</h3>
                      </div>
                      <v-checkbox v-model="checkbox2"></v-checkbox>
                    </div>
                    <div class="single-speaker-selection">
                      <div class="d-flex justify-content-start align-items-center">
                        <div class="speaker-ico-initial">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <h3>Floyd L. Santos</h3>
                      </div>
                      <v-checkbox v-model="checkbox2"></v-checkbox>
                    </div>
                </div>
              </div>
              <div class="speaker-add-section p-3">
                <div class="add-speaker-head">
                  <h5>5 speakers selected</h5>
                  <span>Clear all <v-icon color="#1a74e8" size="20">mdi-close</v-icon></span>
                </div>
                <div class="add-speaker-tab mt-5">
                  <ul>
                    <li>
                      <div class="single-add-speaker-tab">
                        <div class="speaker-tab-img">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <p>Floyed L Santos</p>
                        <span><v-icon color="#959595" size="18px">mdi-close</v-icon></span>
                      </div>
                    </li>

                    <li>
                      <div class="single-add-speaker-tab">
                        <div class="speaker-tab-img">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <p>Floyed L Santos</p>
                        <span><v-icon color="#959595" size="18px">mdi-close</v-icon></span>
                      </div>
                    </li>

                    <li>
                      <div class="single-add-speaker-tab">
                        <div class="speaker-tab-img">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <p>Floyed L Santos</p>
                        <span><v-icon color="#959595" size="18px">mdi-close</v-icon></span>
                      </div>
                    </li>

                    <li>
                      <div class="single-add-speaker-tab">
                        <div class="speaker-tab-img">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <p>Floyed L Santos</p>
                        <span><v-icon color="#959595" size="18px">mdi-close</v-icon></span>
                      </div>
                    </li>


                    <li>
                      <div class="single-add-speaker-tab">
                        <div class="speaker-tab-img">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <p>Floyed L Santos</p>
                        <span><v-icon color="#959595" size="18px">mdi-close</v-icon></span>
                      </div>
                    </li>

                    <li>
                      <div class="single-add-speaker-tab">
                        <div class="speaker-tab-img">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <p>Floyed L Santos</p>
                        <span><v-icon color="#959595" size="18px">mdi-close</v-icon></span>
                      </div>
                    </li>

                    <li>
                      <div class="single-add-speaker-tab">
                        <div class="speaker-tab-img">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <p>Floyed L Santos</p>
                        <span><v-icon color="#959595" size="18px">mdi-close</v-icon></span>
                      </div>
                    </li>

                    <li>
                      <div class="single-add-speaker-tab">
                        <div class="speaker-tab-img">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <p>Floyed L Santos</p>
                        <span><v-icon color="#959595" size="18px">mdi-close</v-icon></span>
                      </div>
                    </li>

                    <li>
                      <div class="single-add-speaker-tab">
                        <div class="speaker-tab-img">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <p>Floyed L Santos</p>
                        <span><v-icon color="#959595" size="18px">mdi-close</v-icon></span>
                      </div>
                    </li>

                    <li>
                      <div class="single-add-speaker-tab">
                        <div class="speaker-tab-img">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <p>Floyed L Santos</p>
                        <span><v-icon color="#959595" size="18px">mdi-close</v-icon></span>
                      </div>
                    </li>

                    <li>
                      <div class="single-add-speaker-tab">
                        <div class="speaker-tab-img">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <p>Floyed L Santos</p>
                        <span><v-icon color="#959595" size="18px">mdi-close</v-icon></span>
                      </div>
                    </li>

                    <li>
                      <div class="single-add-speaker-tab">
                        <div class="speaker-tab-img">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <p>Floyed L Santos</p>
                        <span><v-icon color="#959595" size="18px">mdi-close</v-icon></span>
                      </div>
                    </li>

                    <li>
                      <div class="single-add-speaker-tab">
                        <div class="speaker-tab-img">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <p>Floyed L Santos</p>
                        <span><v-icon color="#959595" size="18px">mdi-close</v-icon></span>
                      </div>
                    </li>

                    <li>
                      <div class="single-add-speaker-tab">
                        <div class="speaker-tab-img">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <p>Floyed L Santos</p>
                        <span><v-icon color="#959595" size="18px">mdi-close</v-icon></span>
                      </div>
                    </li>

                    <li>
                      <div class="single-add-speaker-tab">
                        <div class="speaker-tab-img">
                          <img src="../assets/Images/avatar.jpg"/>
                        </div>
                        <p>Floyed L Santos</p>
                        <span><v-icon color="#959595" size="18px">mdi-close</v-icon></span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            </div>
            
          </div>
        </div>
      </div>


      <!-- Event Modal -->
      <div class="modal fade eventpublishmodal" id="EventPublishModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-body">
             <div class="publish-top-head position-relative">
                <h2>Choose a domain before publish</h2>
                <span data-dismiss="modal" aria-label="Close"><v-icon color="#959595" size="25px">mdi-close</v-icon></span>
              </div>
              <div class="publisho-option">
                
                  <v-radio-group v-model="radios3" mandatory>
                    <div class="single-publish-options selected-class">
                      <div>
                        <v-radio value="radio-1"></v-radio>
                      </div>
                      <div class="free-site-sec">
                        <div class="position-relative">
                          <input type="text" name="" id="" value="https://e2m.live/mysitename"/>
                          <div class="inp-ico"><v-icon color="#959595" size="25px">mdi-earth</v-icon></div>
                        </div>
                      </div>
                    </div>
                    <div class="single-publish-options">
                      <div>
                        <v-radio value="radio-2"></v-radio>
                      </div>
                      <div class="free-site-sec">
                        <div class="position-relative">
                          <h4 class="mb-0">Connect your own customized domain</h4>
                        </div>
                      </div>
                    </div>
                  </v-radio-group>
                <div class="proceed-buttons d-flex justify-content-center align-items-center final-button">
                  <v-btn depressed large color="#1c1d26" outlined plain width="120px" class="mr-3">Cancel</v-btn>
                  <v-btn dark large color="#1a73e8" >Save &amp; Continue</v-btn>
                </div>
              </div>
              <!-- <div class="congrats-head-top position-relative">
                <h3>Congratulations!</h3>
                <p>Your Event site is published now.</p>
                <span data-dismiss="modal" aria-label="Close"><v-icon color="#959595" size="25px">mdi-close</v-icon></span>
              </div>
              <div class="free-site-link mt-12">
                <div class="copy-link-area">
                  <div class="position-relative" style="flex: 1 1 0;">
                    <input type="text" name="" id="" value="https://e2m.live/mysitename"/>
                    <div class="inp-ico"><v-icon color="#959595" size="25px">mdi-earth</v-icon></div>
                  </div>
                  <button>Copy</button>
                </div>
                <a href="" target="_blank" class="open-in-new">Open in new window <v-icon color="#1a73e8" size="20px">mdi-open-in-new</v-icon> </a>
                <div class="share-section">
                  <p>Share with</p>
                  <ul>
                    <li>
                      <v-icon color="#4b4e63" size="25px">mdi-facebook</v-icon>
                    </li>
                    <li>
                      <v-icon color="#4b4e63" size="25px">mdi-facebook-messenger</v-icon>
                    </li>
                    <li>
                      <v-icon color="#4b4e63" size="25px">mdi-linkedin</v-icon>
                    </li>
                    <li>
                      <v-icon color="#4b4e63" size="25px">mdi-twitter</v-icon>
                    </li>
                    <li>
                      <v-icon color="#4b4e63" size="25px">mdi-whatsapp</v-icon>
                    </li>
                    <li>
                      <v-icon color="#4b4e63" size="25px">mdi-email</v-icon>
                    </li>
                  </ul>
                </div>
                <div class="share-section store-wrap mt-8">
                  <p>Download the e2m live event app</p>
                  <ul class="m-0 p-0 d-flex justify-content-center align-items-center">
                    <li><a href=""><img src="../assets/Images/g-store.png"></a></li>
                    <li><a href=""><img src="../assets/Images/app-store.png"></a></li>
                  </ul>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </section>
    

  </div>
</template>
<script>
import db from "../components/firebaseInit";
import APIs from "@/components/APIInit";
import router from "../router";
import jQuery from "jquery";
let $ = jQuery;
var self;
import Vue from "vue";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import axios from "axios";
import { bus } from "@/main";
import Cropper from "../components/CropperComponent.vue";
Vue.use(VueMoment, {
  moment,
});

export default {
  data() {
    return {
          imageRatio: 1 / 1,
      cropImageUrl: null,
      resetCropper: 0,
      displayImageRatio: "1:1",
      BannerURL: "",
      mobileBanner: "",
      desktopBanner: "",
      checkbox: true,
      checkbox2: true,
      radios3: null,
    };
  },
    components: {
    Cropper,
  },
  computed: {
  },
  watch: {
  },
  created() {
    self = this;
    self.initScreen();
    $(window).resize(function () {
      self.initScreen();
    });
  },
  mounted() {
    //self.clientID = self.$route.query.c;
    const HOSTURL = process.env.VUE_APP_LOCALHOST_URL_EDU;
    if (location.host.toLowerCase().indexOf("localhost") >= 0) {
      self.hostName = HOSTURL ? HOSTURL : self.LocalhostDomain();
    } else {
      self.hostName = HOSTURL ? HOSTURL : location.host;
    }
    var path;
    if (this.hostName.toLowerCase().indexOf("uat") > -1) {
      path = "https://resources.e2m.live/uate2monair.appspot.com/";
    } else {
      path = APIs.googleSoragePath;
    }
    axios
      .get(
        path + "OA_UAT%2FClients%2FHosts%2F" + this.hostName + ".json?alt=media"
      )
      .then((res) => {
        if (res && res.data) {
          bus.$emit("EnableHelpChat", "Event", res.data.ClientId);
        }
        self.clientID = res.data.ClientId;
        db.collection("OA_UAT")
          .doc("ClientList")
          .collection("Clients")
          .doc(self.clientID)
          .get()
          .then(function (doc) {
            var data = doc.data();
            self.desktopBanner = data.EventListAssets.banner2048x88;
            self.mobileBanner = data.EventListAssets.banner750x103;
            //  self.BannerURL = data.EventListAssets.banner640x88;
            self.initScreen();
          });
      });
    $("#imgBanner").attr("src", self.BannerURL);
  },
  methods: {
    initScreen() {
      if (window.innerWidth > 768) {
        self.BannerURL = self.desktopBanner;
      } else {
        self.BannerURL = self.mobileBanner;
      }
    },
    goForLogin: function () {
      router.push({ name: "Login" });
    },
        croppedImagePath(blob) {
      console.log(blob);
      this.imgSrc = blob;
      if (this.uploadedFile) {
        alert(this.uploadedFile);

        //vm.uploadImage(blob, `${vm.event_collectionName}/Attendee/`, this.uploadedFile);
        // vm.uploadServerImage(
        //   blob,
        //   `${vm.event_collectionName}/Attendee/`,
        //   vm.uploadedFile
        // );
      }
    },
        update_avatar(input) {
          var self = this;
      //console.log(checkRatio);
      debugger;
      // You can update avatar Here
      if (input.target.files && input.target.files[0]) {
        let file = input.target.files[0];
        this.uploadedFile = file;
        var metadata = {
          contentType: file.type,
        };

        console.log(metadata);
        let validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        // let dimension = fileWH.split("x");

        // console.log(dimension);
        var _URL = window.URL || window.webkitURL;
        let img = new Image();
        var objectUrl = _URL.createObjectURL(file);
        img.onload = function () {
          const reader = new FileReader();
          reader.onload = (e) => {
            //vm.imgSrc = e.target.result;
            self.resetCropper += 1;
            self.cropImageUrl = null;
            self.cropImageUrl = e.target.result;
            


            // setTimeout(() => {
            //   $("#attendeeImageCropperDialog").modal(
            //     { backdrop: "static" },
            //     "show"
            //   );
            // }, 1000);
          };
          reader.readAsDataURL(input.target.files[0]);
          _URL.revokeObjectURL(objectUrl);
        };
        img.src = objectUrl;
      }
    },
  },
};
</script>